import { ACTIONS } from "app/store/actions"
import { deepCopy } from "app/tools/common"
import { INotificationState } from "notification/model"
import { Action, Reducer } from "redux"
import {
  INotificationAddAction,
  INotificationErrorAction,
  INotificationLoadingAction,
  INotificationMarkAsReadAction,
  INotificationSettingsAction,
  INotificationSliderVisibilityAction
} from "./actions"
import { getDefaultNotificationState } from "./state"

export const notificationReducer: Reducer<INotificationState, Action> = (
  state: INotificationState | undefined,
  action: Action
): INotificationState => {
  if (!state) {
    state = getDefaultNotificationState()
  }
  switch (action.type) {
    case ACTIONS.NOTIFICATION_SETTINGS_IS_LOADING: {
      const { isLoading } = action as INotificationLoadingAction
      return {
        ...state,
        isLoadingSettings: isLoading,
        hasLoadingSettingsError: isLoading ? false : state.hasLoadingSettingsError
      }
    }

    case ACTIONS.NOTIFICATION_SETTINGS_HAS_LOADING_ERROR: {
      const { hasError } = action as INotificationErrorAction
      return {
        ...state,
        isLoadingSettings: false,
        hasLoadingSettingsError: hasError
      }
    }

    case ACTIONS.NOTIFICATION_SETTINGS_IS_UPDATING: {
      const { isLoading } = action as INotificationLoadingAction
      return {
        ...state,
        isUpdatingSettings: isLoading
      }
    }

    case ACTIONS.NOTIFICATION_SETTINGS_CHANGE: {
      const { settings } = action as INotificationSettingsAction
      return {
        ...state,
        clientSettings: settings
      }
    }

    case ACTIONS.NOTIFICATION_SETTINGS_UPDATED: {
      const { settings } = action as INotificationSettingsAction
      return {
        ...state,
        serverSettings: settings,
        clientSettings: deepCopy(settings),
        isLoadingSettings: false,
        hasLoadingSettingsError: false,
        isUpdatingSettings: false
      }
    }

    case ACTIONS.NOTIFICATION_ADD: {
      const { notifications } = action as INotificationAddAction
      return {
        ...state,
        notifications,
        isLoadingNewNotification: false,
        hasLoadingNewNotificationError: false,
        lastUpdate: new Date()
      }
    }

    case ACTIONS.NOTIFICATION_VISIBILITY: {
      const { isOpened } = action as INotificationSliderVisibilityAction
      return {
        ...state,
        isSliderOpened: isOpened
      }
    }

    case ACTIONS.NOTIFICATION_IS_LOADING: {
      const { isLoading } = action as INotificationLoadingAction
      return {
        ...state,
        isLoadingNewNotification: isLoading
      }
    }

    case ACTIONS.NOTIFICATION_HAS_LOADING_ERROR: {
      const { hasError } = action as INotificationErrorAction
      return {
        ...state,
        isLoadingNewNotification: false,
        hasLoadingNewNotificationError: hasError
      }
    }

    case ACTIONS.NOTIFICATION_MARK_AS_READ: {
      const { notificationIds } = action as INotificationMarkAsReadAction
      const markAll = notificationIds.length === 0
      return {
        ...state,
        notifications: state.notifications.map(n => {
          if (markAll || notificationIds.includes(n.id as number)) {
            return { ...n, read: true }
          }
          return n
        })
      }
    }

    case ACTIONS.USER_LOGOUT: {
      return getDefaultNotificationState()
    }

    default:
      return state
  }
}
